import React, {Component} from 'react';
import {Switch,Route,BrowserRouter,Redirect} from 'react-router-dom';
import HomePage from './pages/Homepage.js';
import ContentPage from './pages/Contentpage.js';
import Navigation from './components/Navigation/Navigation.js';
import Footer from './components/Footer/Footer';
import topBannerImg from '../src/components/img/TheFarmPost_Masthead.svg';
import basfImg from './components/img/BASF.svg';
import CONSTANTS from './constants/constants';
import FilterPage from './pages/Filterpage.js';
import axios from 'axios';
import {getQSParam} from './utils/Location';
import 'babel-polyfill';
import './App.css';

if(CONSTANTS.IS_LOCAL)
	axios.defaults.withCredentials=true;

class App extends Component{
	toggle_region=(region)=>{
		if(region===undefined){
			window.location.href=(window.global.content_hub.region===CONSTANTS.WEST?'/theFarmPost/pages/home_page_east':'/theFarmPost/pages/home_page_west');
		} else{
			window.global.content_hub.region=region;
			this.forceUpdate();
		}
	}

	render(){
		if(window.global.content_hub.region===undefined){
			let path=window.location.pathname.split('/'),
				page_index=path.indexOf('pages'),
				content_index=path.indexOf('content');
			
			axios.get(window.global.content_hub.API+'api/region',{
				params:{
					page:(page_index>-1 && page_index<path.length-1?path[page_index+1]:undefined),
					content_id:(content_index>-1 && content_index<path.length-1?path[content_index+1]:undefined),
					PIN:getQSParam('PIN')
				}
			}).then(data=>this.toggle_region(data.data.region));

			return <React.Fragment/>;
		}
		
		const default_page=(window.global.content_hub.region===0?'home_page_east':'home_page_west');

    	return(
			<BrowserRouter basename={CONSTANTS.APP_ROUTE}>
				<header className="header">
					<a href="https://agro.basf.ca/">
						<img src={basfImg} alt="basfImg" />
					</a>
				</header>
				<div className="mainBody">
					<a href="/TheFarmPost/" rel="noopener noreferrer">
						<div className="topBanner">
							<img src={topBannerImg} alt="topBanner" />
						</div>
					</a>
					<Navigation toggle_region={(e)=>this.toggle_region()}/>
					<Switch>
						<Route exact path={`/filter/`} render={(props)=>(
							<FilterPage/>
						)}/>
           
						<Route exact path={`${CONSTANTS.PAGE_CONTENT}/:id`} render={(props)=>(
								<ContentPage
									content_id={parseInt(props.match.params.id)}
									loadContent={this.loadContent}
								/>
							)}/>
              
						<Route exact path={`${CONSTANTS.PAGE_PILLAR}/:page`} render={(props)=>(
								<HomePage page={props.match.params.page} loadContent={this.loadContent}/>
							)}/>

           				<Route path="*">
							<Redirect to={`${CONSTANTS.PAGE_PILLAR}/${default_page}`} />
            			</Route>
					</Switch>
				</div>
				<Footer />
			</BrowserRouter>
    	);
 	}
}

export default App;